export class UploadStatus {
    public status: string;
    public success: boolean;
    public filePath: string;
    public progress: number;
}
